import ZboxClosures from "@/views/admin/z-box-closures/ZboxClosures";

export default {
  path: "orders/cierres-de-caja-z",
  name: "zBoxClosures",
  component: ZboxClosures,
  meta: {
    requiresAuth: true
  }
};
